import { render } from "./BuyInsTable.vue?vue&type=template&id=6021bb52&scoped=true"
import script from "./BuyInsTable.vue?vue&type=script&lang=js"
export * from "./BuyInsTable.vue?vue&type=script&lang=js"

import "./BuyInsTable.vue?vue&type=style&index=0&id=6021bb52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6021bb52"]])

export default __exports__